import React, { useState } from "react";
import MetasUnidades from "./components/MetasUnidades";
import ItensDisponiveis from "./components/ItensDisponiveis";
import ResumoDispositivos from "./components/ResumoDispositivos";
import FluxoPessoas from "./components/FluxoPessoas";

export default function UnitsPage() {

  const [selectedUnidadeId, setSelectedUnidadeId] = useState<string | null>(null);

  return (
    <div className="flex mt-3 w-full flex-col gap-5">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <MetasUnidades
          selectedUnidadeId={selectedUnidadeId}
          setSelectedUnidadeId={setSelectedUnidadeId}
        />
        <ItensDisponiveis 
          selectedUnidadeId={selectedUnidadeId}
        />
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <FluxoPessoas 
          selectedUnidadeId={selectedUnidadeId}
        />
        <ResumoDispositivos
          selectedUnidadeId={selectedUnidadeId}
        />
      </div>
    </div>
  );
}


